import Vue from 'vue'
import { Button, Input, Pagination } from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'

Vue.use(Button)
Vue.use(Input)
Vue.use(Pagination)
